import { localStore, viewsActions, viewSettingsActions } from '../../services';
import { ScreenType } from '../../model';

const parseView = ( name, layout ) => {
  if( !layout ) {
    return null;
  }

  if( !layout.title ) {
    console.warn( `Title is missing on the ${name} layout` );
    return null;
  }

  return { 
    key: layout.title,
    screen: ScreenType[layout.screenType].toLowerCase(),
    type: layout.view || 'list'
  };
};

const cleanInitialState = state => {
  const updatedState = {};
  if ( state.product === 'list' ) {
    updatedState.product = 'simple';
  } else if ( state.product === 'tile' ) {
    updatedState.product = 'detailed';
  }

  if ( state.cart === 'list' ) {
    updatedState.cart = 'simple';
  } else if ( state.cart === 'tile' ) {
    updatedState.cart = 'detailed';
  }

  if ( state.accessory === 'linked' ) {
    updatedState.cart = 'simple';
  }

  delete state.categories;

  const newState = { ...state, ...updatedState };
  localStore.set( 'views', newState );
  return newState;
};

const initialState = { accessory: 'simple', product: 'simple', configurator: 'list', cart: 'simple' };
const storedState = cleanInitialState( localStore.get( 'views' ) || initialState );

export const viewsReducer = ( state = storedState, action ) => {
  switch ( action.type ) {
    case viewSettingsActions.LOAD:
      let ns = { ...state };
      
      if( !state.product || !state.configurator || !state.cart ) {
        ns = initialState;
      }
      
      Object.keys( action.data ).forEach( key => {
        const parsed = parseView( key, action.data[key] );
        if ( parsed && !ns[parsed.key] ) {
          ns[parsed.key] = parsed.type;
        }
      } );
      localStore.set( 'views', ns );
      return ns;
    case viewsActions.CHANGEVIEW:
      if( !action.key ) {
        return state;
      }
      let newState = { ...state };
      newState[action.key] = action.viewType;
      localStore.set( 'views', newState );
      return newState;
    default:
      return state;
  }
};

